import { render, staticRenderFns } from "./CustomSelect.vue?vue&type=template&id=4a23ff08&scoped=true"
import script from "./CustomSelect.vue?vue&type=script&lang=js"
export * from "./CustomSelect.vue?vue&type=script&lang=js"
import style0 from "./CustomSelect.vue?vue&type=style&index=0&id=4a23ff08&prod&lang=css"
import style1 from "./CustomSelect.vue?vue&type=style&index=1&id=4a23ff08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a23ff08",
  null
  
)

export default component.exports